export default "__VITE_ASSET__4S_knxIH__"